module.exports = __webpack_public_path__ + "static/wm_logo-e6f62261b88f51db72e89d26eaef5e17.png";